export default __webpack_public_path__ + "src/images/packages/kumbu-kumbu-lodge/b57b2ea92dff43bf794d6609c13e68cb-1.jpg";